import { getMonthOrder } from '@exam-center/exam-event-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Link } from '@exam-center/router';
import { AddRoundedIcon, Box, Button, Flex, Tooltip } from '@shared/components';
import { WithPermission } from '@shared/permissions';
import { dayjs } from '@shared/utils';

const EXAM_EVENT_CREATION_EXPIRY_NOTICE =
  'ไม่สามารถสร้างรอบสอบได้ เนื่องจากเลยวันสิ้นสุดของเดือนนี้';

interface ExamEventCreationButtonProps {
  examCenterCode: string;
  year: string;
  month: string;
}

export default function ExamEventCreationButton(props: Readonly<ExamEventCreationButtonProps>) {
  const { examCenterCode, year, month } = props;

  const endOfMonth = dayjs(`${year}-${getMonthOrder(month) + 1}-01`).endOf('month');
  const isDateAfterEndOfMonth = dayjs().isAfter(endOfMonth);

  return (
    <WithPermission requiredPermission={APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAM_EVENT.CREATE}>
      {/* REMARK: This Box is for tooltip for detect hover - since disabled button cannot be hovered */}
      <Flex sx={{ gap: (theme) => theme.spacing(3) }}>
        <Tooltip
          title={isDateAfterEndOfMonth ? EXAM_EVENT_CREATION_EXPIRY_NOTICE : undefined}
          arrow
          placement='bottom-end'
        >
          <Box>
            <Button
              component={Link}
              to='/:examCenterCode/exam-events/years/:year/months/:month/recurring-create'
              params={{ examCenterCode, year, month }}
              disabled={isDateAfterEndOfMonth}
              color='secondary'
              variant='outlined'
            >
              สร้างรอบสอบแบบซ้ำ
            </Button>
          </Box>
        </Tooltip>
        <Tooltip
          title={isDateAfterEndOfMonth ? EXAM_EVENT_CREATION_EXPIRY_NOTICE : undefined}
          arrow
          placement='bottom-end'
        >
          <Box>
            <Button
              startIcon={<AddRoundedIcon />}
              component={Link}
              to='/:examCenterCode/exam-events/years/:year/months/:month/create'
              params={{ examCenterCode, year, month }}
              disabled={isDateAfterEndOfMonth}
            >
              สร้างรอบสอบ
            </Button>
          </Box>
        </Tooltip>
      </Flex>
    </WithPermission>
  );
}
